module.exports = __webpack_public_path__ + "static/media/placeholder.b8063832.gif";